import fetch from '@/plugin/axios'

export function getAppoints (query) {
  return fetch({
    url: '/api/order/appoint/test/draw',
    method: 'get',
    params: query
  })
}
